import { AppRoutes } from "@/app/routes";
import AppShell from "@/components/layout/AppShell";

export default function AuthenticatedApp() {
  return (
    <AppShell>
      <AppRoutes />
    </AppShell>
  );
}
